import {
  VuexModule,
  Module,
  getModule,
  Mutation,
} from "vuex-module-decorators";
import store from "@/store";

@Module({ dynamic: true, store, name: "dialogs" })
export class DialogsVuexModule extends VuexModule {
  emailConfirmationDialog: EmailDialog = {
    show: false,
    isSent: false,
  };

  @Mutation
  public setEmailConfirmationDialog(value: EmailDialog) {
    this.emailConfirmationDialog = value;
  }

  customDialog = {
    show: false,
    title: "",
    text: "",
  };

  @Mutation
  public setCustomDialog(value: any) {
    this.customDialog = value;
  }

  debtNoticeModal: any = {
    show: false,
    file: null,
    contract: null,
  };

  @Mutation
  public setDebtNoticeModal(value: {}) {
    this.debtNoticeModal = value;
  }

  @Mutation
  public unsetDebtNoticeModal() {
    this.debtNoticeModal = {
      show: false,
      file: null,
      contract: null,
    };
  }
}

export const DialogsModule = getModule(DialogsVuexModule);
